import { useState } from 'react'
import {FaPlay, FaFileAudio, FaFilePdf, FaFileWord, FaFilePowerpoint, FaFileAlt, FaCode } from "react-icons/fa";
import GetLessonType from './GetLessonType';
import { useLocation } from 'react-router-dom';
import Resources from './Resources';
const Curriculum = ({ currentCourse,setPreviewFile }) => {
  const [openDropDown, setOpenDropDown] = useState(null);
  const [viewMore, setViewMore] = useState(5);
  const location = useLocation();
  const isStudentRoute = location.pathname.startsWith('/student');
  const [openResource,setOpenResource]=useState(null)

const getLessonIcon = (type) => {
  switch (type) {
    case "video":
      return <FaPlay className="lesson-icon" />;
    case "audio":
      return <FaFileAudio className="lesson-icon" />;
    case "pdf":
      return <FaFilePdf className="lesson-icon" />;
    case "doc":
      return <FaFileWord className="lesson-icon" />;
    case "ppt":
      return <FaFilePowerpoint className="lesson-icon" />;
    case "txt":
      return <FaFileAlt className="lesson-icon" />;
    case "code":
      return <FaCode className="lesson-icon" />;
    default:
      return <FaFileAlt className="lesson-icon" />; // fallback
  }
};
const handlePreview=(content_file)=>{
     setPreviewFile(content_file)
}

  return (
<div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
  {/* Header with blue accent */}
  <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    </div>
    <div>
      <h3 className="text-xl font-semibold text-gray-900">Curriculum</h3>
      <p className="text-sm text-gray-500 mt-0.5">{currentCourse?.modules?.length || 0} chapters</p>
    </div>
  </div>

  <div className="border border-gray-200 rounded-xl overflow-hidden">
    {currentCourse?.modules?.slice(0, viewMore).map((chapter, index) => (
      <div className="border-b border-gray-200 last:border-b-0" key={index}>
        {/* Chapter Header */}
        <div className="flex justify-between items-center p-5 bg-gray-50">
          <div className="flex items-center gap-2">
            {/* <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div> */}
            <span className="font-medium text-gray-900">
              Chapter {index + 1}: {chapter.title}
            </span>
            <span className="text-xs px-2 py-1 bg-white text-gray-600 rounded-lg">
              {chapter.lessons.length} {chapter.lessons.length === 1 ? 'Lesson' : 'Lessons'}
            </span>
          </div>
          <button
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white transition-colors"
            onClick={() => setOpenDropDown(openDropDown === index ? null : index)}
          >
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {openDropDown === index ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              )}
            </svg>
          </button>
        </div>

        {/* Lessons */}
        {openDropDown === index && (
          <div className="divide-y divide-gray-100">
            {chapter.lessons.map((lesson, lessonIndex) => (
              <div className="p-5 hover:bg-gray-50/50 transition-colors" key={lessonIndex}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 flex-1">
                    <div className="w-8 h-8 bg-[#e8f0f7] text-[#0f6abf] border border-gray-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      {isStudentRoute ? (
                        <GetLessonType type={lesson.type} lesson={lesson} setPreviewFile={setPreviewFile} />
                      ) : (
                        getLessonIcon(lesson.type)
                      )}
                    </div>
                    <span className="text-sm font-medium text-gray-700">{lesson.title}</span>
                  </div>
                  
                  <div className="flex items-center gap-3">
                    {isStudentRoute && lesson.resources?.length > 0 && (
                      <button
                        onClick={() => setOpenResource(prev => prev === lesson.id ? null : lesson.id)}
                        className="px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors"
                      >
                        {openResource === lesson.id ? 'Hide Resources' : `${lesson.resources.length} Resources`}
                      </button>
                    )}

                    {!isStudentRoute && lesson.isPreview && currentCourse.course_type === 'paid' && (
                      <button
                        className="flex items-center gap-2 px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors"
                        onClick={() => handlePreview(lesson.content_file)}
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          {lesson.type.toLowerCase() === "video" ? (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                          ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15.536a5 5 0 001.414 1.414m2.828-9.9a9 9 0 012.828-2.828" />
                          )}
                        </svg>
                        {lesson.type} Preview
                      </button>
                    )}
                  </div>
                </div>

                {/* Resources */}
                {openResource === lesson.id && (
                  <div className="mt-4 pl-11">
                    <Resources resources={lesson.resources} />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    ))}

    {/* View More Button */}
    {currentCourse?.modules?.length > 5 && viewMore < currentCourse?.modules?.length && (
      <button
        onClick={() => setViewMore(currentCourse.modules.length)}
        className="w-full py-4 bg-gray-50 border-t border-gray-200 text-[#0f6abf] text-sm font-medium hover:bg-gray-100 transition-colors flex items-center justify-center gap-2"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
        View Full Curriculum ({currentCourse.modules.length} Chapters)
      </button>
    )}
  </div>
</div>
  );
};

export default Curriculum;
